import { CompanyData, QuestionnaireInfoDto } from '../../types';

/**
 * @french
 * État initial du slice de balance.
 */
export const companiesInitialState = {
  selectedCompany: null as CompanyData | null,
  questionnaireList: [] as QuestionnaireInfoDto[],
};

/**
 * @french
 * Type dérivé de l’état initial.
 */
export type CompaniesState = typeof companiesInitialState;
